module.exports = __webpack_public_path__ + "img/447.b04bd904.jpg";